export default {
  default: {
    super: {
      shop: true,
      staff: true,
      takeaway: ["all"],
      report: ["all"],
      product: {
        issue: true,
        distribute: ["all"],
        redeem: ["all"],
      },
      estamp: {
        issue: true,
        distribute: ["all"],
      },
      promotionCode: true,
      welcome: true,
      ad: true,
      pushNotification: true,
    },
    no: {
      shop: false,
      staff: false,
      takeaway: [],
      report: [],
      product: {
        issue: false,
        distribute: [],
        redeem: [],
      },
      estamp: {
        issue: false,
        distribute: [],
      },
      promotionCode: false,
      welcome: false,
      ad: false,
      pushNotification: false,
    },
  },
};
